var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height pa-0",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }